import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import {
  PERMISSIONS,
  FIELDPERMISSIONS,
} from "../../../../PermissionsConstants";
import { useHistory } from "react-router-dom";
import { mainSelectedTab } from "../../../atoms";
import { useEmployeeNumber } from "../hooks/useEmployeeNumber";
import AddButton from "components/AddButton";
import CloseIconButton from "components/CloseIconButton";
import { UsersIcon } from "@heroicons/react/24/solid";
import EditOutlineButton from "components/EditOutlineButton";
import {
  empAddState,
  FranchiseOfficeDetailsData,
  employeeFromOffice,
  prodCodeModal,
} from "../atoms/atoms";
import GoogleMaps from "components/GoogleMaps";
import { accountAtom } from "../../../../Login/atoms/AccountAtom";
import FranchiseOfficeDetailsModal from "./FranchiseOfficeDetailsModal";
import { OfficeTabs } from "../../../../OfficeTab/OfficeTabs";
import { useEffect, useState } from "react";
import EHOrgChart from "./EmployeeOrgChart/EHOrgChart";
import { useGetProucerCodeByEmpId } from "../hooks/useGetProducerCodeByEmpId";
import EmployeeProducerCodeSection from "./EmployeeProducerCodesSection";
import ReactTooltip from "react-tooltip";
import { useGetEmployeeOfficeHierarchyLeadership } from "../hooks/usetGetEmployeeOfficeHierarchyLeadership";
import EmployeeNsaHierarchyLeadership from "./EmployeeNsaHierarchyLeadership";
import CheckboxInlineHookForm from "components/CheckboxInlineHookForm";

const EmployeesExpandedRow = ({
  rowData,
  DepOption,
  handleEdit,
  onClickCancelShow,
  actionDisable,
  hyperlinkDisable,
  hasUSAdd,
  hasUSEdit,
  mexicoAdd,
  mexicoEdit,
}) => {
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const [isAdd, setAddState] = useRecoilState(empAddState);

  const viewContactPermission =
    PERMISSIONS.permission_employee_contactdetails_view;
  const viewAdditionalPermission =
    PERMISSIONS.permission_employee_additionaldetails_view;
  const viewTrainingPermission = PERMISSIONS.permission_employee_training_view;
  const viewAssociatedOfficeAddress =
    PERMISSIONS.permission_employee_associatedOffice_view;
  const acquisitionName =
    FIELDPERMISSIONS.fieldpermission_employee_acquisitionname;
  const isSeparationType =
    FIELDPERMISSIONS.fieldpermission_employee_separationtype;
  const isSeparationReason =
    FIELDPERMISSIONS.fieldpermission_employee_separationtype;
  const isRehirable = FIELDPERMISSIONS.fieldpermission_employee_rehirable;
  const viewProdCodePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_view;

  const userPermissions = useRecoilValue(permissionsSelector);
  const history = useHistory();
  const user = useRecoilValue(accountAtom);
  const setShowFromOffice = useSetRecoilState(employeeFromOffice);
  const setOpenProdCodeModal = useSetRecoilState(prodCodeModal);
  const [fetchEmployee, setFetchEmployee] = useState();

  const employeeId = rowData?.employeeId ? rowData?.employeeId : 0;
  const isNotFranchiseType =
    rowData.employeeTypeName?.toLowerCase() !== "franchise";
  const leadershipEmployeeId =
    rowData?.employeeId && isNotFranchiseType ? rowData?.employeeId : 0;

  const { data: employeeData, isFetching } = useEmployeeNumber(employeeId);

  const { data: prodCodeData } = useGetProucerCodeByEmpId(employeeId);
  const { data: employeeOfficeHierarchyLeadership } =
    useGetEmployeeOfficeHierarchyLeadership(leadershipEmployeeId);

  //From Office Edit Emp
  const isEditFromOffice = localStorage.getItem("isEditFromOffice");

  useEffect(() => {
    if (isEditFromOffice && employeeData) {
      handleEdit({ ...employeeData });
      setShowFromOffice(true);
    }
  }, [isEditFromOffice, employeeData]);

  useEffect(() => {
    if (employeeData) {
      setFetchEmployee(employeeData);
    }
  }, [employeeData, fetchEmployee]);

  //CloseFromProducerCode
  useEffect(() => {
    const fromModal = localStorage.getItem("fromModal");
    if (fromModal === "true") {
      setOpenProdCodeModal(true);
    }
    localStorage.removeItem("fromModal");
  }, [setOpenProdCodeModal]);

  const addressRequired = employeeData?.officeName
    ?.toLowerCase()
    ?.includes("work from home");
  const salesRequired =
    employeeData?.employeeTypeName?.toLowerCase() === "sales";
  const notTerminated = employeeData?.status?.toLowerCase() !== "terminated";
  const [showOfficeDetails, setShowOfficeDetails] = useRecoilState(
    FranchiseOfficeDetailsData,
  );
  const handleOfficeDetails = () => {
    setShowOfficeDetails(true);
  };
  const closeOfficeDetails = () => {
    setShowOfficeDetails(false);
  };
  const associatedAddress =
    employeeData &&
    employeeData?.associatedOfficeAddress?.map((x) => {
      return {
        suiteNumber: x.suiteNumber,
        city: x.city,
        address: x.address,
        state: x.state,
        zipCode: x.zipCode,
        country: x.country,
        latitude: x.shippingAddressLatitude,
        longitude: x.shippingAddressLongitude,
      };
    });

  return (
    <>
      {!isFetching && employeeData && (
        <div className="px-8 py-4 space-y-2">
          <div className="relative py-2 box-shadow border-quinary border-l-2">
            <CloseIconButton onClick={() => onClickCancelShow()} />
            <div className="flex mx-4 justify-between pb-1 border-secondary border-b-2">
              <div className="flex gap-2 items-center">
                <div>
                  <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Employee
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    {employeeData.fullname}
                  </h1>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="flex items-center gap-2">
                  {(hasUSAdd || mexicoAdd) && (
                    <AddButton
                      buttonText="Add"
                      onClick={() => setAddState(!isAdd)}
                    />
                  )}
                  {((!employeeData.isMexico && hasUSEdit) ||
                    (employeeData.isMexico && mexicoEdit)) && (
                    <EditOutlineButton
                      buttonText="Edit"
                      onClick={() => {
                        handleEdit({ ...employeeData });
                      }}
                      disabled={actionDisable(employeeData)}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="bg-bgDB">
              {!employeeData?.employeeTypeName?.includes("Franchise") &&
                !employeeData.isMexico && (
                  <div className="flex justify-end items-center gap-3 mr-6 mt-3">
                    <CheckboxInlineHookForm
                      name="isHealthcare"
                      label="Healthcare"
                      readOnly
                      isView
                      checked={employeeData?.isHealthcare}
                    />
                    <CheckboxInlineHookForm
                      name="isPremierHome"
                      label="Premier Home"
                      readOnly
                      isView
                      checked={employeeData?.isPremierHome}
                    />
                    <CheckboxInlineHookForm
                      name="isPriorityHome"
                      label="Priority Home"
                      readOnly
                      isView
                      checked={employeeData?.isPriorityHome}
                    />
                  </div>
                )}
              {userPermissions.includes(viewContactPermission) ? (
                <div className="mx-4 mt-4 mb-2 bg-white rounded-lg box-shadow">
                  <div className="text-quinary font-bold font-sans py-2 px-6">
                    Contact Details
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                    <div className="p-2 divide-y">
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Record ID:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.employeeId}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Name:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          <span className="">{employeeData.salutation} </span>
                          {employeeData.fullname}
                        </div>
                      </div>
                      {(user?.isFranchise &&
                        employeeData?.employeeTypeName === "Franchise") ||
                      employeeData?.employeeTypeName === "Franchise" ? (
                        <>
                          <div className="grid grid-cols-3 p-2">
                            <div className="col-span-1 mx-4 expandedLabel fontExpand">
                              Main Office:
                            </div>

                            {hyperlinkDisable(employeeData) ? (
                              <div className="col-span-2 expandedData fontExpand">
                                {employeeData.mainOffice}
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="text-left blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                                onClick={() => {
                                  localStorage.setItem(
                                    "empId",
                                    employeeData?.employeeId,
                                  );
                                  const url = "/officesettings/officesetting";
                                  history.push({
                                    pathname: url,
                                    state: {
                                      officeCode: employeeData?.mainOffice,
                                      employeeId: employeeData?.employeeId,
                                      action: "Employee",
                                    },
                                  });

                                  window.location.reload();

                                  const userTabs = OfficeTabs.filter((tab) =>
                                    userPermissions.includes(tab.permission),
                                  ).map((tab) => ({
                                    to: tab.to,
                                  }));

                                  const index = userTabs.findIndex(
                                    (c) => c.to === url,
                                  );
                                  setSelectedIndex(index);
                                }}
                              >
                                {employeeData.mainOffice}
                              </button>
                            )}
                          </div>

                          <div className="grid grid-cols-3 p-2">
                            <div className="col-span-1 mx-4 expandedLabel fontExpand">
                              Office Details:
                            </div>

                            <button
                              type="button"
                              className="text-left col-span-2 blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                              onClick={handleOfficeDetails}
                            >
                              View Office Details
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="grid grid-cols-3 p-2">
                            <div className="col-span-1 mx-4 expandedLabel fontExpand">
                              Office Name:
                            </div>
                            {hyperlinkDisable(employeeData) ? (
                              <div className="expandedData fontExpand">
                                {employeeData.officeName}
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="text-left blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                                onClick={() => {
                                  localStorage.setItem(
                                    "empId",
                                    employeeData?.employeeId,
                                  );
                                  const url = "/officesettings/officesetting";
                                  history.push({
                                    pathname: url,
                                    state: {
                                      officeCode: employeeData?.officecode,
                                      employeeId: employeeData?.employeeId,
                                      action: "Employee",
                                    },
                                  });

                                  window.location.reload();

                                  const userTabs = OfficeTabs.filter((tab) =>
                                    userPermissions.includes(tab.permission),
                                  ).map((tab) => ({
                                    to: tab.to,
                                  }));

                                  const index = userTabs.findIndex(
                                    (c) => c.to === url,
                                  );
                                  setSelectedIndex(index);
                                }}
                              >
                                {employeeData.officeName}
                              </button>
                            )}
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <div className="col-span-1 mx-4 expandedLabel fontExpand">
                              Office Code:
                            </div>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.officecode}
                            </div>
                          </div>
                        </>
                      )}

                      {addressRequired && salesRequired && notTerminated && (
                        <div className="grid grid-cols-3 p-2">
                          <label className="col-span-1 mx-4 expandedLabel fontExpand">
                            Associated Office:
                          </label>
                          <button
                            type="button"
                            className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                            onClick={() => {
                              const url = "/officesettings/officesetting";
                              history.push({
                                pathname: url,
                                state: {
                                  associatedOfficeId:
                                    employeeData?.associatedOfficeId,
                                  employeeId: employeeData?.employeeId,
                                  action: "Employees",
                                },
                              });

                              window.location.reload();

                              const userTabs = OfficeTabs.filter((tab) =>
                                userPermissions.includes(tab.permission),
                              ).map((tab) => ({
                                to: tab.to,
                              }));

                              const index = userTabs.findIndex(
                                (c) => c.to === url,
                              );
                              setSelectedIndex(index);
                            }}
                          >
                            {employeeData.associatedTo}
                          </button>
                        </div>
                      )}

                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Business Operation:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.businessOperation}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Department:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {
                            DepOption?.filter(
                              (x) => x.value === employeeData.department,
                            )[0]?.label
                          }
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Home Company:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.homeCompanyName}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Title:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.employeeTitleName}
                        </div>
                      </div>
                      {employeeOfficeHierarchyLeadership === "" &&
                        !employeeData.isSplc && (
                          <div className="grid grid-cols-3 p-2">
                            <label className="col-span-1 mx-4 expandedLabel fontExpand">
                              Reports To:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.reportsToFullname}
                            </div>
                          </div>
                        )}
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Employee Type:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.employeeTypeName}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Employment Type:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.employmenttype}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand ">
                          Status:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.status}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Previous Employee Status:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.previousemployeestatus}
                        </div>
                      </div>
                    </div>
                    <div className="p-2 divide-y">
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Preferred Name:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.preferredName}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Phone:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.phone}
                        </div>
                      </div>

                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Mobile:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.mobile}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Email:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.email}
                        </div>
                      </div>
                      {!employeeData.isSplc &&
                        employeeData?.reportsToEmployeeId &&
                        employeeOfficeHierarchyLeadership === "" && (
                          <>
                            <div className="grid grid-cols-3 p-2">
                              <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                Reports To Status:
                              </label>
                              <div className="col-span-2 expandedData fontExpand">
                                {employeeData.reportstostatus}
                              </div>
                            </div>
                            <div className="grid grid-cols-3 p-2">
                              <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                Reports To Term Date:
                              </label>
                              <div className="col-span-2 expandedData fontExpand">
                                {employeeData.reportstotermdate &&
                                  new Date(
                                    employeeData.reportstotermdate,
                                  ).toLocaleDateString()}
                              </div>
                            </div>
                          </>
                        )}
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Forward Emails To:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.forwardemailsto}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          UPN:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.upn}
                        </div>
                      </div>
                      {userPermissions.includes(acquisitionName) && (
                        <div className="grid grid-cols-3 p-2">
                          <label className="col-span-1 mx-4 expandedLabel fontExpand">
                            Acquisition Name:
                          </label>
                          <div className="col-span-2 expandedData fontExpand">
                            {employeeData.acquisitionName}
                          </div>
                        </div>
                      )}
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Country:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {employeeData.isMexico ? "Mexico" : "United States"}
                        </div>
                      </div>
                      {employeeData.isMexico && (
                        <div className="grid grid-cols-3 p-2">
                          <label className="col-span-1 mx-4 expandedLabel fontExpand">
                            AD Override Group:
                          </label>
                          <div className="col-span-2 expandedData fontExpand">
                            {employeeData.adOverrideGroupNames}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="w-full">
                {userPermissions.includes(viewAdditionalPermission) ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Additional Details
                          </span>
                        </Disclosure.Button>

                        <Disclosure.Panel>
                          <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Employee Id:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.employeenumber}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Bilingual:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.bilingual}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Hire Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.hiredate &&
                                    new Date(
                                      employeeData.hiredate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Termination Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.terminationdate &&
                                    new Date(
                                      employeeData.terminationdate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Rehire Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.rehireDate &&
                                    new Date(
                                      employeeData.rehireDate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  On Leave Effective Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.onLeaveEffectiveDate &&
                                    new Date(
                                      employeeData.onLeaveEffectiveDate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Leave Return Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.leavereturndate &&
                                    new Date(
                                      employeeData.leavereturndate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Change Effective Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.changeeffectivedate &&
                                    new Date(
                                      employeeData.changeeffectivedate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                            </div>
                            {employeeData.isMexico &&
                              employeeData.status === "Terminated" && (
                                <div className="p-2 divide-y">
                                  {userPermissions.includes(
                                    isSeparationType,
                                  ) && (
                                    <div className="grid grid-cols-3 p-2">
                                      <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                        Separation Type:
                                      </label>
                                      <div className="col-span-2 expandedData fontExpand">
                                        {employeeData.separationTypeName}
                                      </div>
                                    </div>
                                  )}
                                  {userPermissions.includes(
                                    isSeparationReason,
                                  ) && (
                                    <div className="grid grid-cols-3 p-2">
                                      <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                        Separation Reason:
                                      </label>
                                      <div className="col-span-2 expandedData fontExpand">
                                        {employeeData.separationReasonName}
                                      </div>
                                    </div>
                                  )}
                                  {userPermissions.includes(isRehirable) && (
                                    <div className="grid grid-cols-3 p-2">
                                      <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                        Rehirable:
                                      </label>
                                      <div className="col-span-2 expandedData fontExpand">
                                        {employeeData.rehirableName}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  ""
                )}
              </div>
              <div className="w-full">
                {employeeData.isSplc &&
                employeeData?.employeeTypeName?.toLowerCase() !==
                  "franchise" ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Hierarchy and Leadership
                          </span>
                        </Disclosure.Button>

                        <Disclosure.Panel>
                          <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Hierarchy Channel:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {"SPLC"}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Hierarchy Leadership:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.hierarchyLeadership}
                                </div>
                              </div>
                              {employeeData.hierarchyLeadership ===
                                "Executive" && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Reports To:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {employeeData.reportsToFullname}
                                  </div>
                                </div>
                              )}
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  {employeeData.hierarchyLeadership ===
                                  "Team Manager" ? (
                                    <>
                                      <i>(Reports To)</i> Team Manager:
                                    </>
                                  ) : (
                                    "Team Manager:"
                                  )}
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.teamManager}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  {employeeData.hierarchyLeadership ===
                                  "District Manager" ? (
                                    <>
                                      <i>(Reports To)</i> District Manager:
                                    </>
                                  ) : (
                                    "District Manager:"
                                  )}
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.districtManager}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  {employeeData.hierarchyLeadership ===
                                  "Director" ? (
                                    <>
                                      <i>(Reports To)</i> Director:
                                    </>
                                  ) : (
                                    "Director:"
                                  )}
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.director}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  {employeeData.hierarchyLeadership ===
                                  "Vice President" ? (
                                    <>
                                      <i>(Reports To)</i> Vice President:
                                    </>
                                  ) : (
                                    "Vice President:"
                                  )}
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.vicePresident}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  {employeeData.hierarchyLeadership ===
                                  "Senior Vice President" ? (
                                    <>
                                      <i>(Reports To)</i> Senior Vice President:
                                    </>
                                  ) : (
                                    "Senior Vice President:"
                                  )}
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.seniorVicePresident}
                                </div>
                              </div>
                            </div>
                            <div className="p-2 divide-y">
                              {employeeData.hierarchyLeadership ===
                                "Executive" && (
                                <div className="grid grid-cols-3 p-2 invisible">
                                  <label className="col-span-1 mx-4">
                                    Spacer
                                  </label>
                                  <div className="col-span-2">Spacer</div>
                                </div>
                              )}
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Reports To Status:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.reportstostatus}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2 border-b border-gray-300">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Reports To Term Date:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.reportstotermdate &&
                                    new Date(
                                      employeeData.reportstotermdate,
                                    ).toLocaleDateString()}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Team Name:
                                </label>
                                <>
                                  <ReactTooltip
                                    place="top"
                                    effect="solid"
                                    type="info"
                                  />
                                  <div
                                    className="col-span-2 expandedData fontExpand truncate"
                                    data-tip={
                                      employeeData?.teamManager &&
                                      employeeData?.teamName?.length > 50
                                        ? employeeData.teamName
                                        : ""
                                    }
                                  >
                                    {employeeData?.teamManager
                                      ? employeeData?.teamName?.length > 50
                                        ? employeeData.teamName
                                            .slice(0, 50)
                                            .trim() + "..."
                                        : employeeData.teamName
                                      : ""}
                                  </div>
                                </>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  District:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.districtName}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  State:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.stateName}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Market:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.marketName}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Business Unit:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.businessUnitName}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  employeeData?.reportsToEmployeeId &&
                  employeeOfficeHierarchyLeadership !== "" && (
                    <EmployeeNsaHierarchyLeadership
                      leadership={employeeOfficeHierarchyLeadership}
                    />
                  )
                )}
              </div>
              <div className="flex flex-cols-2 w-full">
                {userPermissions.includes(viewTrainingPermission) ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="w-1/2 ml-4 mr-2 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Address Information
                          </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className="text-xs">
                          <div className="grid grid-cols-1">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Physical Address:
                                </label>
                                <div className="col-span-2 fontExpand">
                                  <div>{employeeData.suiteNumber}</div>
                                  <div>{employeeData.address}</div>
                                  <div>
                                    {employeeData.city} ,{employeeData.state}{" "}
                                    {""}
                                    {employeeData.zipCode} {""}
                                  </div>
                                  <div>{employeeData.country}</div>

                                  {employeeData.latitude &&
                                  employeeData.longitude ? (
                                    <GoogleMaps
                                      center={{
                                        lat: parseFloat(employeeData.latitude),
                                        lng: parseFloat(employeeData.longitude),
                                      }}
                                      physicalAddress={
                                        employeeData.suiteNumber +
                                        ", " +
                                        employeeData.address +
                                        " " +
                                        employeeData.city +
                                        ", " +
                                        employeeData.employeState +
                                        " " +
                                        employeeData.zipCode +
                                        " " +
                                        employeeData.country
                                      }
                                    />
                                  ) : (
                                    <span className="italic text-xs text-red-500">
                                      Warning: Address is not yet verified.
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  ""
                )}
                {userPermissions.includes(viewAssociatedOfficeAddress) ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="w-1/2 mr-4 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Associated Office Address
                          </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className="text-xs">
                          <div className="grid grid-cols-1">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Physical Address:
                                </label>
                                {associatedAddress !== undefined ? (
                                  <>
                                    <div className="col-span-2 expandedData fontExpand">
                                      <div>
                                        {associatedAddress[0]?.suiteNumber}
                                      </div>
                                      <div>{associatedAddress[0]?.address}</div>
                                      <div>
                                        {associatedAddress[0]?.city} {""}
                                        {associatedAddress[0]?.state} {""}
                                        {associatedAddress[0]?.zipCode}
                                        {""}
                                      </div>
                                      <div>{associatedAddress[0]?.country}</div>
                                    </div>
                                    <div></div>
                                    {associatedAddress[0]?.latitude &&
                                    associatedAddress[0]?.longitude ? (
                                      <GoogleMaps
                                        center={{
                                          lat: parseFloat(
                                            associatedAddress[0]?.latitude,
                                          ),
                                          lng: parseFloat(
                                            associatedAddress[0]?.longitude,
                                          ),
                                        }}
                                        physicalAddress={
                                          associatedAddress[0]?.address +
                                          " " +
                                          associatedAddress[0]?.city +
                                          ", " +
                                          associatedAddress[0]?.state +
                                          " " +
                                          associatedAddress[0]?.zipCode +
                                          " " +
                                          associatedAddress[0]?.country
                                        }
                                      />
                                    ) : (
                                      <span className="italic text-xs text-red-500">
                                        Warning: Address is not yet verified.
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <span className="italic text-xs text-red-500">
                                    Warning: Address is not yet verified.
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  ""
                )}
              </div>
              <div className="flex flex-cols-2 w-full">
                {userPermissions.includes(viewTrainingPermission) ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="w-1/2 ml-4 mr-2 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Corporate Employee Information
                          </span>
                        </Disclosure.Button>

                        <Disclosure.Panel className="text-xs">
                          <div className="grid grid-cols-1">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Mirror Employee:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.mirroremployee}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Mirror Employee Email:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.mirroremployeeemail}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Mirror Employee HR ID:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.mirroremployeehrid}
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className=" col-span-1 mx-4 expandedLabel fontExpand">
                                  Email Domain:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.emailDomainName}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  ""
                )}
                {userPermissions.includes(viewTrainingPermission) ? (
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="w-1/2 mr-4 mb-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Training and Licensing
                          </span>
                        </Disclosure.Button>

                        <Disclosure.Panel className="text-xs">
                          <div className="grid grid-cols-1">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Training Location:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {employeeData.traininglocation}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ) : (
                  ""
                )}
              </div>

              {userPermissions.includes(viewProdCodePermission) ? (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRight
                          className={`${
                            open ? "transform rotate-90" : " text-gray-500"
                          } text-gray-500 w-5 h-5 `}
                        />
                        <span className="disclosureLabel ml-2">
                          Producer Codes Appointed
                        </span>
                      </Disclosure.Button>

                      <Disclosure.Panel className="text-xs">
                        {
                          <EmployeeProducerCodeSection
                            employeeId={employeeId}
                            prodCodeData={prodCodeData}
                          />
                        }
                      </Disclosure.Panel>
                    </div>
                  )}
                </Disclosure>
              ) : (
                ""
              )}

              {userPermissions.includes(viewTrainingPermission) ? (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRight
                          className={`${
                            open ? "transform rotate-90" : " text-gray-500"
                          } text-gray-500 w-5 h-5 `}
                        />
                        <span className="disclosureLabel ml-2">
                          Organization
                        </span>
                      </Disclosure.Button>

                      <Disclosure.Panel className="text-xs pb-4">
                        <EHOrgChart empData={rowData} />

                        {/* Emp Org Chart */}
                      </Disclosure.Panel>
                    </div>
                  )}
                </Disclosure>
              ) : (
                ""
              )}
              <Disclosure defaultOpen>
                {({ open }) => (
                  <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
                    <Disclosure.Button className="disclosureBtn ml-2">
                      <ChevronRight
                        className={`${
                          open ? "transform rotate-90" : " text-gray-500"
                        } text-gray-500 w-5 h-5 `}
                      />
                      <span className="disclosureLabel ml-2">
                        System Information
                      </span>
                    </Disclosure.Button>

                    <Disclosure.Panel className="text-xs">
                      <div className="grid grid-cols-1 md:grid-cols-2">
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="col-span-1 mx-4 expandedLabel fontExpand">
                              Created By:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.createdby}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="col-span-1 mx-4 expandedLabel fontExpand">
                              Modified By:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.lastmodifiedby}
                            </div>
                          </div>
                        </div>
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="col-span-1 mx-4 expandedLabel fontExpand">
                              Created Date:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.createdDate
                                ? new Date(
                                    employeeData.createdDate,
                                  ).toLocaleDateString() +
                                  " " +
                                  new Date(
                                    employeeData.createdDate,
                                  ).toLocaleTimeString(navigator.language, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : ""}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="col-span-1 mx-4 expandedLabel fontExpand">
                              Modified Date:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {employeeData.lastModifiedDate
                                ? new Date(
                                    employeeData.lastModifiedDate,
                                  ).toLocaleDateString() +
                                  " " +
                                  new Date(
                                    employeeData.lastModifiedDate,
                                  ).toLocaleTimeString(navigator.language, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Disclosure.Panel>
                  </div>
                )}
              </Disclosure>
            </div>
          </div>
        </div>
      )}
      {showOfficeDetails && (
        <FranchiseOfficeDetailsModal
          data={employeeData}
          showOfficeDetails={showOfficeDetails}
          closeOfficeDetails={closeOfficeDetails}
        />
      )}
    </>
  );
};

export default EmployeesExpandedRow;
